<script lang="ts">
    export let id
    window.onclick = function (event) {
        let modal = document.getElementById("modal-bg");
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }
    /*    export let modalTitle
        export let modalText*/
    const title = ["Hőszigetelt lamella", "Parapet rendszer", "Zip Screen", "Elhúzható üvegrendszer"]
    const text = ["Elérhető opcióként a lamella poliuretán habbal tölthető, mely extra szigetelést biztosít.", "Motorosan vezérelhető függőleges parapet rendszer.", "A WINDSTOR egy egyedi függőleges ZIP screen rendszer, mely megakadályozza az esővíz és a szél behatolását. Elérhető a PVC kristályos anyagban, amely teljesen áttetsző.", "Ez az elegáns üvegrendszer teljesen vízálló, és a speciálisan kialakított vízelvezető még a legkisebb esőcseppeket is elvezeti. 3 vagy 5 sínes verzióban kapható a szélességtől függően, illetve akár dupla üvegezéssel a megfelelő szigetelés érdekében."]
    const link = ["https://pergolagroup.hu/bioklimatikus-pergolak/skyroof-prestige/", "https://pergolagroup.hu/uvegrendszerek/szabalyozhato-parapet-rendszer/", "https://pergolagroup.hu/arnyekolok/windstor-foggoleges-zip-screen/", "https://pergolagroup.hu/uvegrendszerek/tolhato-uvegrendszerek/"]
    const pic = ["modal_insulated.png", "modal_parapet.jpg", "modal_zip.png", "modal_glass.jpg"]
</script>

<div id="modal-bg" class="modal select-none">

    <!-- Modal content -->
    <div id="modal-content" class="p-4 modal-content text-white 3xl:container relative"
         style="background: rgb(5,30,46);">
        <span id="modal-1" on:click={() => {
            let modal = document.getElementById("modal-bg");
            modal.style.display = "none";
        }} class="close absolute right-4 top-4">&times;</span>
        <p class="font-bold text-2xl lg:text-3xl">{title[id]}</p>
        {#if id === 0}
            <div class="col span_12 dark left">
                <div class="vc_col-sm-8 wpb_column column_container vc_column_container col no-extra-padding instance-23 no-left-margin p-4"
                     data-t-w-inherits="default" data-border-radius="none" data-shadow="none" data-border-animation=""
                     data-border-animation-delay="" data-border-width="none" data-border-style="solid"
                     data-border-color="" data-bg-cover="" data-padding-pos="all" data-has-bg-color="false"
                     data-bg-color="" data-bg-opacity="1" data-hover-bg="" data-hover-bg-opacity="1" data-animation=""
                     data-delay="0">
                    <div class="column-bg-overlay"></div>
                    <div class="vc_column-inner">
                        <div class="wpb_wrapper">
                            <div id="fws_6056dca51e53b" data-midnight="" data-column-margin="default"
                                 data-bg-mobile-hidden="" class="wpb_row vc_row-fluid vc_row inner_row standard_section"
                                 style="padding-top: 0px; padding-bottom: 0px;">
                                <div class="row-bg-wrap">
                                    <div class="row-bg"></div>
                                </div>
                                <div class="col col span_12 left space-x-4 flex justify-around">
                                    <div class="vc_col-sm-6 wpb_column column_container vc_column_container col no-extra-padding instance-24 no-left-margin"
                                         data-t-w-inherits="default" data-shadow="none" data-border-radius="none"
                                         data-border-animation="" data-border-animation-delay=""
                                         data-border-width="none" data-border-style="solid" data-border-color=""
                                         data-bg-cover="" data-padding-pos="all" data-has-bg-color="false"
                                         data-bg-color="" data-bg-opacity="1" data-hover-bg="" data-hover-bg-opacity="1"
                                         data-animation="" data-delay="0">
                                        <div class="column-bg-overlay"></div>
                                        <div class="vc_column-inner">
                                            <div class="wpb_wrapper">
                                                <div class="img-with-aniamtion-wrap" data-max-width="100%"
                                                     data-border-radius="none">
                                                    <div class="inner"><img
                                                            class="img-with-animation skip-lazy animated-in"
                                                            data-shadow="none" data-shadow-direction="middle"
                                                            data-delay="0" height="450" width="563"
                                                            data-animation="fade-in"
                                                            src="https://pergolagroup.hu/wp-content/uploads/2019/06/climatecontrol3.png"
                                                            alt=""
                                                            srcset="https://pergolagroup.hu/wp-content/uploads/2019/06/climatecontrol3.png 563w, https://pergolagroup.hu/wp-content/uploads/2019/06/climatecontrol3-300x240.png 300w"
                                                            sizes="100vw" style="opacity: 1;"></div>
                                                </div>
                                                <h5 style="color: #bf1e2e;text-align: center" class="vc_custom_heading">
                                                    Alap</h5>
                                                <h3 style="color: #bf1e2e;text-align: center" class="vc_custom_heading">
                                                    LÉGCSATORNÁK</h3>
                                                <div class="wpb_text_column wpb_content_element">
                                                    <div class="wpb_wrapper"><p style="text-align: center;">A lamella
                                                        kialakítása már önmagában is remek szigetelőképességgel
                                                        rendelkezik.</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vc_col-sm-6 wpb_column column_container vc_column_container col no-extra-padding instance-25"
                                         data-t-w-inherits="default" data-shadow="none" data-border-radius="none"
                                         data-border-animation="" data-border-animation-delay=""
                                         data-border-width="none" data-border-style="solid" data-border-color=""
                                         data-bg-cover="" data-padding-pos="all" data-has-bg-color="false"
                                         data-bg-color="" data-bg-opacity="1" data-hover-bg="" data-hover-bg-opacity="1"
                                         data-animation="" data-delay="0">
                                        <div class="column-bg-overlay"></div>
                                        <div class="vc_column-inner">
                                            <div class="wpb_wrapper">
                                                <div class="img-with-aniamtion-wrap" data-max-width="100%"
                                                     data-border-radius="none">
                                                    <div class="inner"><img
                                                            class="img-with-animation skip-lazy animated-in"
                                                            data-shadow="none" data-shadow-direction="middle"
                                                            data-delay="0" height="450" width="563"
                                                            data-animation="fade-in"
                                                            src="https://pergolagroup.hu/wp-content/uploads/2019/06/climatecontrol2.png"
                                                            alt=""
                                                            srcset="https://pergolagroup.hu/wp-content/uploads/2019/06/climatecontrol2.png 563w, https://pergolagroup.hu/wp-content/uploads/2019/06/climatecontrol2-300x240.png 300w"
                                                            sizes="100vw" style="opacity: 1;"></div>
                                                </div>
                                                <h5 style="color: #bf1e2e;text-align: center" class="vc_custom_heading">
                                                    Szigetelt</h5>
                                                <h3 style="color: #bf1e2e;text-align: center" class="vc_custom_heading">
                                                    SZIGETELT LAMELLÁK</h3>
                                                <div class="wpb_text_column wpb_content_element">
                                                    <div class="wpb_wrapper"><p style="text-align: center;">Elérhető
                                                        opcióként a lamella poliuretán habbal tölthető, mely extra
                                                        szigetelést biztosít.</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <div class="items-center md:items-start flex flex-col md:flex-row justify-between space-x-2">
                <img class="h-auto md:h-64 lg:h-64 xl:h-80 md:pr-4 py-4" src="/img/{pic[id]}"
                     alt="Elhúzható üvegrendszer">
                <p class="pt-4">{text[id]}</p>
                {#if id === 1}
                    <div class="vc_column-inner"></div>
                    <div class="w-48 wpb_wrapper"><h5 style="color: #56717b;text-align: left" class="vc_custom_heading">
                        Üveg</h5>
                        <div class="nectar-fancy-ul" data-list-icon="none" data-animation="false"
                             data-animation-delay="0" data-color="accent-color" data-alignment="left">
                            <ul>
                                <li><i class="icon-default-style none accent-color"></i> 8mm egyrétegű edzett</li>
                                <li><i class="icon-default-style none accent-color"></i> 5mm+12mm+5mm kétrétegű</li>
                            </ul>
                        </div>
                        <h5 style="color: #56717b;text-align: left" class="vc_custom_heading">Színek</h5>
                        <div class="nectar-fancy-ul" data-list-icon="none" data-animation="false"
                             data-animation-delay="0" data-color="accent-color" data-alignment="left">
                            <ul>
                                <li><i class="icon-default-style none accent-color"></i> Átlátszó (alap)</li>
                                <li><i class="icon-default-style none accent-color"></i> Kék</li>
                                <li><i class="icon-default-style none accent-color"></i> Zöld</li>
                                <li><i class="icon-default-style none accent-color"></i> Füst</li>
                            </ul>
                        </div>
                    </div>
                {/if}
                {#if id === 2}
                    <div class="vc_column-inner">
                        <div class="wpb_wrapper w-64"><h3 style="font-size: 28px;color: #8c654c;text-align: center"
                                                          class="vc_custom_heading">WINDSTOR</h3>
                            <div class="divider-wrap" data-alignment="default">
                                <div style="height: 10px;" class="divider"></div>
                            </div>
                            <div class="wpb_raw_code wpb_content_element wpb_raw_html">
                                <div class="wpb_wrapper"><h5 style="color:#8c654c;">Maximum méretek WS100<span
                                        style="font-size:10px"></span></h5>
                                    <div style="display: table;width: 100%;border-collapse: collapse; margin-bottom:0">
                                        <div style="display: table-row-group;">
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c;">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Szélesség <span
                                                        style="font-size:10px"></span></div>
                                                <div style="display: table-cell;">100-400 cm</div>
                                            </div>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Hosszúság <span
                                                        style="font-size:10px">PVC</span></div>
                                                <div style="display: table-cell;">100-250 cm</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display: table;width: 100%;border-collapse: collapse; margin-bottom:0">
                                        <div style="display: table-row-group;">
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c;">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Hosszúság <span
                                                        style="font-size:10px">Anyag</span></div>
                                                <div style="display: table-cell;">100-300 cm</div>
                                            </div>
                                            <h5 style="color:#8c654c;padding-top:30px">Maximum méretek WS120<span
                                                    style="font-size:10px"></span></h5>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Szélesség <span
                                                        style="font-size:10px"></span></div>
                                                <div style="display: table-cell;">100-500 cm</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display: table;width: 100%;border-collapse: collapse; margin-bottom:0">
                                        <div style="display: table-row-group;">
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c;">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Hosszúság <span
                                                        style="font-size:10px">PVC</span></div>
                                                <div style="display: table-cell;">100-300 cm</div>
                                            </div>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Hosszúság <span
                                                        style="font-size:10px">Anyag</span></div>
                                                <div style="display: table-cell;">100-350 cm</div>
                                            </div>
                                        </div>
                                    </div>
                                    <h5 style="color:#8c654c;padding-top:30px">Opciók, Kiegészítők </h5>
                                    <div style="display: table;width: 100%;border-collapse: collapse;">
                                        <div style="display: table-row-group;">
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Érzékelők</div>
                                                <div style="display: table-cell;">Napérzékelő, Szélérzékelő</div>
                                            </div>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c">Szín</div>
                                                <div style="display: table-cell;">RAL színek</div>
                                            </div>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Anyag</div>
                                                <div style="display: table-cell;">Soltis 86 + 92 / W96</div>
                                            </div>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c">Screen anyag</div>
                                                <div style="display: table-cell;">Kristály PVC</div>
                                            </div>
                                        </div>
                                    </div>
                                    <h5 style="color:#8c654c;padding-top:30px">Alapfelszereltség</h5>
                                    <div style="display: table;width: 100%;border-collapse: collapse; margin-bottom:0">
                                        <div style="display: table-row-group;">
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c;">
                                                <div style="display: table-cell;color:#8c654c;width:40%">Vezérlés
                                                    típusa
                                                </div>
                                                <div style="display: table-cell;">Távirányítható motor</div>
                                            </div>
                                            <div style="display: table-row;border-bottom: 2px solid #8c654c">
                                                <div style="display: table-cell;color:#8c654c">Szín</div>
                                                <div style="display: table-cell;">RAL9010 (Fehér)</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
                {#if id === 3}
                    <div class="wpb_wrapper p-4 flex-1"><h5 style="color: #56717b;text-align: left"
                                                            class="vc_custom_heading w-40">Üveg</h5>
                        <div class="nectar-fancy-ul" data-list-icon="none" data-animation="false"
                             data-animation-delay="0" data-color="accent-color" data-alignment="left">
                            <ul>
                                <li><i class="icon-default-style none accent-color"></i> 10mm edzett üveg</li>
                                <li><i class="icon-default-style none accent-color"></i> 10mm edzet üveg (színes)</li>
                            </ul>
                        </div>
                        <h5 style="color: #56717b;text-align: left" class="vc_custom_heading">Színek</h5>
                        <div class="nectar-fancy-ul" data-list-icon="none" data-animation="false"
                             data-animation-delay="0" data-color="accent-color" data-alignment="left">
                            <ul>
                                <li><i class="icon-default-style none accent-color"></i> Átlátszó (alap)</li>
                                <li><i class="icon-default-style none accent-color"></i> Kék</li>
                                <li><i class="icon-default-style none accent-color"></i> Zöld</li>
                                <li><i class="icon-default-style none accent-color"></i> Füst</li>
                            </ul>
                        </div>
                        <div class="wpb_raw_code wpb_content_element wpb_raw_html">
                            <div class="wpb_wrapper"><h5 style="color:#56717b;">Méretek</h5>
                                <div style="display: table;width: 100%;border-collapse: collapse; margin-bottom:0">
                                    <div style="display: table-row-group;">
                                        <div style="display: table-row;border-bottom: 2px solid #56717b;">
                                            <div style="display: table-cell;color:#56717b;width:60%">Max. Magasság</div>
                                            <div style="display: table-cell;">260 cm</div>
                                        </div>
                                        <div style="display: table-row;border-bottom: 2px solid #56717b">
                                            <div style="display: table-cell;color:#56717b">Max. Szélesség</div>
                                            <div style="display: table-cell;">600 cm</div>
                                        </div>
                                        <div style="display: table-row;border-bottom: 2px solid #56717b">
                                            <div style="display: table-cell;color:#56717b">Min. panel szélesség</div>
                                            <div style="display: table-cell;">75 cm</div>
                                        </div>
                                        <div style="display: table-row;border-bottom: 2px solid #56717b">
                                            <div style="display: table-cell;color:#56717b">Max. panel szélesség</div>
                                            <div style="display: table-cell;">100 cm</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        {/if}

        <form target="_blank" action="{link[id]}">
            <input class="bg-blue-600 hover:bg-blue-700 cursor-pointer" type="submit" value="További infók"/>
        </form>
    </div>
</div>

<style>
    /* Bg */
    .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 50; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    /* Modal Content/Box */
    .modal-content {
        background-color: #fefefe;
        margin: 15% auto; /* 15% from the top and centered */
        padding: 20px;
        border: 1px solid #888;
        width: 80%; /* Could be more or less, depending on screen size */
    }

    /* The Close Button */
    .close {
        cursor: pointer;
        color: #aaa;
        font-size: 28px;
        font-weight: bold;
    }

    .close:hover {
        color: #f4f4f4;
    }

    .close:focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }
</style>